var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "merchant-info-setting" }, [
    _c("div", { staticClass: "flex-justify-between mb-24" }, [
      _c("div", { staticClass: "setting-item-label text-14-500" }, [
        _vm._v(_vm._s(_vm.$t("merchant.merchant_no"))),
      ]),
      _c(
        "div",
        { staticClass: "setting-item-value text-14-500 color-488CE8" },
        [_vm._v(" " + _vm._s(_vm.userInfo.merchant_no) + " ")]
      ),
    ]),
    _c("div", { staticClass: "flex-justify-between mb-24" }, [
      _c("div", { staticClass: "setting-item-label text-14-500" }, [
        _vm._v(_vm._s(_vm.$t("merchant.merchant_name"))),
      ]),
      _c(
        "div",
        { staticClass: "setting-item-value text-14-500 color-488CE8" },
        [_vm._v(" " + _vm._s(_vm.userInfo.merchant_name) + " ")]
      ),
    ]),
    _c("div", { staticClass: "flex-justify-between mb-24" }, [
      _c("div", { staticClass: "setting-item-label text-14-500" }, [
        _vm._v(_vm._s(_vm.$t("merchant.merchant_type"))),
      ]),
      _c(
        "div",
        { staticClass: "setting-item-value text-14-500 color-488CE8" },
        [
          _vm._v(
            " " +
              _vm._s(_vm.getMerchantTypeMap(_vm.userInfo.merchant_type)) +
              " "
          ),
        ]
      ),
    ]),
    _c("div", { staticClass: "flex-justify-between mb-24" }, [
      _c("div", { staticClass: "setting-item-label text-14-500" }, [
        _vm._v(_vm._s(_vm.$t("merchant.notification_email"))),
      ]),
      _c(
        "div",
        { staticClass: "setting-item-value text-14-500 color-488CE8" },
        [
          _vm._v(
            " " +
              _vm._s(_vm.userInfo.merchant_basic_info.notification_email) +
              " "
          ),
        ]
      ),
    ]),
    _c("div", { staticClass: "flex-justify-between mb-24" }, [
      _c("div", { staticClass: "setting-item-label text-14-500" }, [
        _vm._v(_vm._s(_vm.$t("merchant.notification_phone"))),
      ]),
      _c(
        "div",
        { staticClass: "setting-item-value text-14-500 color-488CE8" },
        [
          _vm._v(
            " " +
              _vm._s(_vm.userInfo.merchant_basic_info.notification_phone) +
              " "
          ),
        ]
      ),
    ]),
    _c("div", { staticClass: "flex-justify-between mb-24" }, [
      _c("div", { staticClass: "setting-item-label text-14-500" }, [
        _vm._v(_vm._s(_vm.$t("merchant.contract_effect_time"))),
      ]),
      _c(
        "div",
        { staticClass: "setting-item-value text-14-500 color-488CE8" },
        [
          _vm._v(
            " " +
              _vm._s(_vm.userInfo.contract_validity_start) +
              " " +
              _vm._s(
                _vm.userInfo.contract_validity_start
                  ? _vm.$t("merchant.to")
                  : "-"
              ) +
              " " +
              _vm._s(_vm.userInfo.contract_validity_end) +
              " "
          ),
        ]
      ),
    ]),
    _c("div", { staticClass: "flex-justify-between mb-24" }, [
      _c("div", { staticClass: "setting-item-label text-14-500" }, [
        _vm._v(_vm._s(_vm.$t("merchant.merchant_status"))),
      ]),
      _c(
        "div",
        { staticClass: "setting-item-value text-14-500 color-488CE8" },
        [
          _vm._v(
            " " +
              _vm._s(_vm.getMerchantStatusMap(_vm.userInfo.merchant_status)) +
              " "
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }